import GravityForms from './gravity-forms';

new GravityForms();
